import React from 'react'

import {
    StyledBreadcrumbContainer,
    StyledBreadcrumb,
    StyledChevron,
    StyledSevenChevron,
    StyledLink,
    StyledSpan,
    StyledPageTitle,
} from 'component-library/navigation/Breadcrumb/Breadcrumb.styled'
import {
    SponsoredTopic,
    Props as SponsoredTopicProps,
} from 'component-library/advertising/SponsoredTopic/SponsoredTopic'
import { ThemedRender } from 'component-library/__styling/themed-render'
import { ThemeMargins } from 'component-library/__styling/settings/metrics'

export type LinkProps = {
    text: string
    href?: string
}

export interface Props {
    items: LinkProps[]
    enableHeaderTag?: boolean
    verticalSpacing?: keyof ThemeMargins | undefined
}

export const Breadcrumb: React.FC<Props & SponsoredTopicProps> = ({
    items,
    sponsor,
    enableHeaderTag,
    verticalSpacing,
}) => {
    if (!items || items.length === 0) {
        return null
    }

    const numberOfLevels = items.length
    const breadcrumbs = () =>
        items.map((item, index) => {
            const isLast = index === numberOfLevels - 1

            const chevron = (
                <ThemedRender
                    thewest={() => <StyledChevron />}
                    perthnow={() => <StyledChevron />}
                    sevennews={() => <StyledSevenChevron />}
                />
            )

            const itemLink = item.href ? (
                <React.Fragment key={index}>
                    <StyledLink enableHeaderTag={enableHeaderTag} to={item.href} isLast={isLast}>
                        {item.text}
                    </StyledLink>
                    {!isLast && chevron}
                </React.Fragment>
            ) : (
                <React.Fragment key={index}>
                    <StyledSpan isLink={false} isLast={isLast}>
                        {item.text}
                    </StyledSpan>
                    {!isLast && chevron}
                </React.Fragment>
            )

            if (enableHeaderTag && isLast) {
                return <StyledPageTitle key={index}>{itemLink}</StyledPageTitle>
            } else {
                return <React.Fragment key={index}>{itemLink}</React.Fragment>
            }
        })
    return (
        <StyledBreadcrumbContainer verticalSpacing={verticalSpacing}>
            <StyledBreadcrumb>{breadcrumbs()}</StyledBreadcrumb>
            {sponsor && <SponsoredTopic sponsor={sponsor} />}
        </StyledBreadcrumbContainer>
    )
}
Breadcrumb.displayName = 'Breadcrumb'
